<footer>
    <div class="center py-s">
        <p class="by">by</p>
        <img class="thalesImg" src="assets/thales.svg" alt="thales">
    </div>
</footer>